import { useEffect } from 'react';
import { Log } from '@/shared/Log';

export const usePreloadAzureVideo = (isVideo?: boolean) => {
    useEffect(() => {
        const isEmbedded = (window as any).isEmbedded === true;
        if (!isVideo || isEmbedded) return;

        // Lazy-load Azure Video module
        import('@/features/azureVideo/Index').catch((err) =>
            Log.error('Failed to preload Azure Video', err),
        );
    }, [isVideo]);
};
